// @ts-nocheck
import addPanelDataConsts from '@/addPanelDataConsts';

export default {
  type: addPanelDataConsts.SECTIONS_TYPES.THEME,
  hide: false,
  title: 'add_section_label_theme_shape',
  subNavigationTitle: 'add_section_label_theme_shape',
  presetTitle: 'add_section_label_theme_shape',
  tooltipTitle: 'add_section_label_theme_shape',
  subNavigationHide: false,
  showSectionHeader: true,
  additionalBehaviours: {
    labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.NONE,
    infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
    iconEnabledForComps: [],
  },
  props: {
    compTypes: ['wysiwyg.viewer.components.FiveGridLine'],
    verticalMargin: 30,
    horizontalMargin: 20,
    maxFontSize: 10,
    scaleProportion: {
      x: 1,
      y: 1,
    },
  },
  help: {
    hide: false,
    text: 'add_section_info_text_theme_general',
  },
};
